import { BillingInfo } from '../../types/types'
import Image from 'next/image'

type propTypes = {
  billingInfo: BillingInfo
}

export default function CardInfoComponent(props: propTypes) {
  const { billingInfo } = props
  return (
    <>
      <div className="d-flex">
        {billingInfo && billingInfo.ccDetails && (
          <div className="d-flex align-items-center">
            <img
              src={`/logos/${billingInfo.ccDetails.cardType.toLowerCase()}.png`}
              alt={`${billingInfo.ccDetails.cardType} logotype`}
              width="48"
              height="33"
            />
            <span className="ml-10 text-small">{`**** **** **** ${billingInfo.ccDetails.lastFour}`}</span>
            <div className="text-small align-items-center color-stone-5">
              &nbsp;
              {billingInfo.ccDetails.expiryMonth.toString().padStart(2, '0')}/
              {billingInfo.ccDetails.expiryYear.toString().substring(2, 4)}
            </div>
          </div>
        )}
        {billingInfo &&
          billingInfo.paymentMethod === 'paypal_billing_agreement' && (
            <div className="d-flex align-items-center">
              <img
                className="mr-20"
                src={`/logos/paypal.png`}
                alt="paypal logotype"
                width="48"
                height="33"
              />
              Paypal Billing Agreement
            </div>
          )}
      </div>
    </>
  )
}
